(function () {
  'use strict';
  var form = document.getElementById('pce-contact-form');
  if (!form) return;
  var params = new URLSearchParams(window.location.search);
  var product = (params.get('product') || '').trim().slice(0, 200);
  var handle = params.get('handle') || '';
  if (!product) return;

  function setHidden(name, value) {
    var input = form.querySelector('[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  setHidden('contact[Product]', product);
  if (/^[a-z0-9][a-z0-9-]*$/.test(handle)) {
    setHidden('contact[Product URL]', window.location.origin + '/products/' + handle);
  }
  var subject = form.querySelector('[name="contact[subject]"]');
  if (subject) subject.value = 'Product enquiry: ' + product;
  var message = form.querySelector('[name="contact[body]"]');
  if (message && !message.value.trim()) {
    message.value = 'I would like to enquire about ' + product + '. Please advise on availability and suitable alternatives for my location.\n\nMy location or the office I first contacted: ';
  }
})();
